(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_faq-item"] && !Shopify.designMode) return;
  try {
    class FaqItem extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.faq-item__question');
      this.answer = this.querySelector('.faq-item__answer');
      this.toggle = this.querySelector('.faq-item__toggle');
      this.init();
    }

    init() {
      if (this.button) {
        this.button.addEventListener('click', () => this.toggleAnswer());
      }
    }

    toggleAnswer() {
      const isOpen = this.answer.classList.contains('faq-item__answer--open');

      // Close other items in the same category
      const category = this.closest('.faq-category');
      if (category) {
        category.querySelectorAll('faq-item').forEach(item => {
          if (item !== this) {
            const otherAnswer = item.querySelector('.faq-item__answer');
            const otherToggle = item.querySelector('.faq-item__toggle');
            const otherButton = item.querySelector('.faq-item__question');
            if (otherAnswer && otherAnswer.classList.contains('faq-item__answer--open')) {
              otherAnswer.classList.remove('faq-item__answer--open');
              if (otherToggle) otherToggle.classList.remove('faq-item__toggle--open');
              if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
            }
          }
        });
      }

      // Toggle current item
      if (isOpen) {
        this.answer.classList.remove('faq-item__answer--open');
        this.toggle.classList.remove('faq-item__toggle--open');
        this.button.setAttribute('aria-expanded', 'false');
      } else {
        this.answer.classList.add('faq-item__answer--open');
        this.toggle.classList.add('faq-item__toggle--open');
        this.button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  if (!customElements.get('faq-item')) {
    customElements.define('faq-item', FaqItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    class FaqBlock extends HTMLElement {
    constructor() {
      super();
      this.tabsContainer = this.querySelector('.faq-block__tabs');
      this.categories = this.querySelectorAll('.faq-category');
      this.init();
    }

    init() {
      // Generate tabs from category data attributes
      this.categories.forEach((category, index) => {
        const title = category.dataset.categoryTitle;
        const categoryId = category.dataset.categoryId;

        const tab = document.createElement('button');
        tab.className = 'faq-block__tab' + (index === 0 ? ' faq-block__tab--active' : '');
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.setAttribute('aria-controls', 'faq-category-' + categoryId);
        tab.setAttribute('data-tab-target', categoryId);
        tab.setAttribute('data-testid', 'faq-tab');
        tab.textContent = title;

        tab.addEventListener('click', () => this.switchTab(tab));
        this.tabsContainer.appendChild(tab);
      });

      this.tabs = this.querySelectorAll('.faq-block__tab');

      // Ensure first category is visible on init
      if (this.categories.length > 0) {
        this.categories.forEach((category, index) => {
          if (index === 0) {
            category.classList.add('faq-category--active');
            category.removeAttribute('hidden');
          } else {
            category.classList.remove('faq-category--active');
            category.setAttribute('hidden', '');
          }
        });
      }
    }

    switchTab(clickedTab) {
      const targetId = clickedTab.dataset.tabTarget;

      // Update tabs
      this.tabs.forEach(tab => {
        tab.classList.remove('faq-block__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });
      clickedTab.classList.add('faq-block__tab--active');
      clickedTab.setAttribute('aria-selected', 'true');

      // Update category panels
      this.categories.forEach(category => {
        if (category.dataset.categoryId === targetId) {
          category.classList.add('faq-category--active');
          category.removeAttribute('hidden');
        } else {
          category.classList.remove('faq-category--active');
          category.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('faq-block')) {
    customElements.define('faq-block', FaqBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
